import moment from 'moment';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  PROJECTS_GET_PROJECT_ALLOCATIONS_BEGIN,
  PROJECTS_GET_PROJECT_ALLOCATIONS_SUCCESS,
  PROJECTS_GET_PROJECT_ALLOCATIONS_FAILURE,
  PROJECTS_GET_PROJECT_ALLOCATIONS_DISMISS_ERROR,
} from './constants';
import { DATE_INPUT_FORMAT } from '../../../common/constants';
import { protectedJsonGet } from '../../../utils/api';
import { roleIsFilled } from '../../allocations/utils/allocationUtils';

export function getProjectAllocations(accountId, projectId) {
  return {
    type: PROJECTS_GET_PROJECT_ALLOCATIONS_BEGIN,
    accountId,
    projectId,
  };
}

export function dismissGetProjectAllocationsError() {
  return {
    type: PROJECTS_GET_PROJECT_ALLOCATIONS_DISMISS_ERROR,
  };
}

export function* doGetProjectAllocations(action) {
  const { accountId, projectId } = action;
  let res;
  try {
    res = yield call(protectedJsonGet, `accounts/${accountId}/projects/${projectId}/allocations`, { personstate: 'all', relativeDate: moment().local().format(DATE_INPUT_FORMAT) });
  } catch (err) {
    yield put({
      type: PROJECTS_GET_PROJECT_ALLOCATIONS_FAILURE,
      data: { error: err },
    });
    return;
  }
  yield put({
    type: PROJECTS_GET_PROJECT_ALLOCATIONS_SUCCESS,
    projectId,
    data: res,
  });
}

export function* watchGetProjectAllocations() {
  yield takeLatest(PROJECTS_GET_PROJECT_ALLOCATIONS_BEGIN, doGetProjectAllocations);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case PROJECTS_GET_PROJECT_ALLOCATIONS_BEGIN:
      return {
        ...state,
        getProjectAllocationsPending: true,
        getProjectAllocationsError: null,
      };

    case PROJECTS_GET_PROJECT_ALLOCATIONS_SUCCESS: {
      const { projectId, data } = action;
      const { projectSelections } = state;

      const filteredProjects = state.filteredProjects.map((project) => {
        if (project.id === projectId && project.roles) {
          const totalCount = project.roles.length;
          let unfilledCount = 0;

          project.roles.forEach((role) => {
            const projectAllocation = data?.length > 0 ? data.find(alloc => alloc.roleId === role.id) : null;

            const { startDate, endDate, requirements } = role;

            if (!projectAllocation || !roleIsFilled(startDate, endDate, requirements, projectAllocation.allocations)) {
              unfilledCount += 1;
            }
          });

          return {
            ...project,
            totalRoles: totalCount,
            unfilledRoles: unfilledCount,
          };
        }
        return project;
      });

      const newProjectSelections = { ...projectSelections };
      Object.keys(newProjectSelections).forEach((selectionId) => {
        const selectedProject = newProjectSelections[selectionId];
        if (selectedProject && selectedProject.id === projectId && selectedProject.roles) {
          const totalCount = selectedProject.roles.length;
          let unfilledCount = 0;

          selectedProject.roles.forEach((role) => {
            const projectAllocation = data?.length > 0 ? data.find(alloc => alloc.roleId === role.id) : null;

            const { startDate, endDate, requirements } = role;
            if (!projectAllocation || !roleIsFilled(startDate, endDate, requirements, projectAllocation.allocations)) {
              unfilledCount += 1;
            }
          });

          newProjectSelections[selectionId] = {
            ...selectedProject,
            totalRoles: totalCount,
            unfilledRoles: unfilledCount,
          };
        }
      });

      return {
        ...state,
        filteredProjects,
        projectAllocations: {
          ...state.projectAllocations,
          [projectId]: action.data,
        },
        getProjectAllocationsPending: false,
        getProjectAllocationsError: null,
        projectSelections: newProjectSelections,
      };
    }
    case PROJECTS_GET_PROJECT_ALLOCATIONS_FAILURE:
      return {
        ...state,
        getProjectAllocationsPending: false,
        getProjectAllocationsError: action.data.error,
      };

    case PROJECTS_GET_PROJECT_ALLOCATIONS_DISMISS_ERROR:
      return {
        ...state,
        getProjectAllocationsError: null,
      };

    default:
      return state;
  }
}
